import {useGetMeQuery} from "../../../api/about.slice.ts";


export const AboutPage = () => {
    const {data} = useGetMeQuery()

    return <>
        <h1>About</h1>
        <p>Current Tenant: {data?.tenant || "EMPTY"} </p>
        <p>Current Username: {data?.username || "EMPTY"}  </p>
    </>
}